import Axios from 'axios';

export default Axios.create({
  baseURL: `${process.env.REACT_APP_TUTOPIYA_ONBOARDING_BE_BASE_URL}`,
  headers: {
    'Content-type': 'application/x-www-form-urlencoded',
  },
});
